export const iconMap = {
	"e2e": {
		shortName: "e2e",
		longName: "e2e",
		class: "e2e",
		description: "Comprehensive end-to-end testing to simulate real user scenarios.",
	},
	"integration": {
		shortName: "intg",
		longName: "integration",
		class: "integration",
		description: "Testing the interaction between different components or modules.",
	},
	"secret_detection": {
		shortName: "secr",
		longName: "secret detect",
		class: "secret-detection",
		description: "Scanning for sensitive data leaks or vulnerabilities.",
	},
	"unit_test": {
		shortName: "unit",
		longName: "unit test",
		class: "unit-test",
		description: "Isolated tests for individual units of code to ensure functionality.",
	},
	"accessibility": {
		shortName: "acce",
		longName: "accessibility",
		class: "accessibility",
		description: "Ensuring the application is usable by individuals with disabilities.",
	},
	"lighthouse": {
		shortName: "perf",
		longName: "lighthouse",
		class: "lighthouse",
		description: "Performance auditing and optimization using Google's Lighthouse tool.",
	},
	"k6": {
		shortName: "k6",
		longName: "k6",
		class: "k6",
		description: "Load testing for assessing system performance under expected load.",
	},
	"k6-loadtest-cloud": {
		shortName: "load cld",
		longName: "k6 cloud",
		class: "k6-loadtest-cloud",
		description: "Scalable cloud-based load testing using k6.",
	},
	"k6-loadtest-local": {
		shortName: "load loc",
		longName: "k6 local",
		class: "k6-loadtest-local",
		description: "Load testing conducted locally with k6 for performance evaluation.",
	},
};